import React from 'react';
import { Outlet } from 'react-router-dom';

// The shell for a store's own domain.
//
// Masked storefront routes used to mount the back-office `Layout`, which
// renders none of its chrome on a storefront — `hideSidebar` and
// `storefrontRoute` in layout.jsx gate every branch off — yet still cost a
// shopper the whole import graph behind it: the sidebar menus (and
// html-react-parser), the sidebar hover animation (and GSAP), the account
// menu, the order/customer autocomplete. Worse, layout.jsx holds the page
// behind `if (loading) return <DataLoading title="Loading Theme" fullPage />`
// until /api/v1/Theme answers — an eight-second timeout in front of the first
// paint, for a theme the storefront then throws away.
//
// Read end to end, what Layout actually renders for a storefront route is
// these two elements. Kept statically imported on purpose: the boot was three
// serial JS round trips (entry → layout + its graph → storefront), and a
// three-line layout removes a whole tier of that.
// (Moving onto a new release is handled once for every layout, in App.jsx.)
const StorefrontLayout = () => <Outlet />;

export default StorefrontLayout;
